import React from "react";
import { Flame, Inbox, CheckCircle2, Image as ImageIcon } from "lucide-react";

const Stat = ({ icon: Icon, label, value, tint }) => (
  <div className="bg-white rounded-2xl p-5 paper-shadow" data-testid={`stat-${label}`}>
    <Icon className="w-6 h-6" style={{ color: tint }} strokeWidth={2.2} />
    <p className="font-display font-black text-3xl mt-2 text-[#2b2620]">{value}</p>
    <p className="tag-label text-[#a0703c] mt-1">{label}</p>
  </div>
);

export function ProfileStats({ stats }) {
  const dash = "—";
  return (
    <div className="md:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-4">
      <Stat icon={Inbox} label="Notes received" value={stats?.received ?? dash} tint="#007aff" />
      <Stat icon={CheckCircle2} label="Completed" value={stats?.completed ?? dash} tint="#34c759" />
      <Stat icon={ImageIcon} label="Polaroids" value={stats?.polaroids ?? dash} tint="#ff9500" />
      <Stat icon={Flame} label="Streak days" value={stats?.streak_days ?? dash} tint="#ff3b30" />
    </div>
  );
}
